import { DateString } from '@sdk/types';
import { createContext, useContext, ReactNode } from 'react';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

type ToastShiftScheduleActions = {
  importShiftSchedules: (date: DateString) => void;
  close: () => void;
  sendModalVisibleAnalyticsEvent: () => void;
  currentUser: AuthUserType;
};

const ToastShiftScheduleModalContext = createContext<ToastShiftScheduleActions>(
  {} as ToastShiftScheduleActions
);

export const useToastShiftScheduleModal = () => useContext(ToastShiftScheduleModalContext);

type Props = {
  actions: ToastShiftScheduleActions;
  children: ReactNode;
};

export const ToastShiftScheduleModalProvider = ({ actions, children }: Props) => {
  return (
    <ToastShiftScheduleModalContext.Provider value={actions}>
      {children}
    </ToastShiftScheduleModalContext.Provider>
  );
};
